<script setup lang="ts">
import {
	StepperRoot,
	useForwardPropsEmits,
	type StepperRootEmits,
	type StepperRootProps,
} from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";

interface Props extends StepperRootProps, ClassProps {}

const props = defineProps<Props>();
const emit = defineEmits<StepperRootEmits>();

const delegatedProps = useDelegatedProps(props);

const forwarded = useForwardPropsEmits(delegatedProps, emit);
</script>

<template>
	<StepperRoot v-slot="slotProps" :class="cn(props.class)" v-bind="forwarded">
		<slot v-bind="slotProps" />
	</StepperRoot>
</template>
